<template>
  <div>
    <v-tabs
      v-model="tab"
      fixed-tabs
      v-show="tabs.length > 0"
      center-active
      show-arrows
    >
      <v-tab v-for="tab in tabs" :key="tab.route" :to="tab.route" flat>
        {{ tab.name }}
      </v-tab>
    </v-tabs>
    <v-divider></v-divider>
  </div>
</template>

<script>
export default {
  data: () => ({
    tab: 0,
    tabs: [],
  }),

  created() {
    this.updateTabs();
  },

  watch: {
    $route() {
      this.updateTabs();
    },
  },

  methods: {
    updateTabs() {
      if (this.$route.path.includes("user/list-bet")) {
        this.tabs = [
          { name: this.$t("sports"), route: "sportsBetting" },
          ...(
            this.$store.state.operators.casino > 0 &&
            this.$store.state.operators.credit == 2 ? [{
              name: this.$t("casino"),
              route: "casinoBetting",
            }] : []
          ),
        ];
      } else {
        this.tabs = [];
      }
    },
  },
};
</script>
